var _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 306.14 306.14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 153.07,
    cy: 153.07,
    r: 153.07,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-229.37 -308.69)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 334.04,
    cy: 399.32,
    r: 14.563,
    fill: "#a4a4a4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 476.01,
    cy: 400.8,
    r: 14.563,
    fill: "#a4a4a4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m427.18 415.83 26.214 97.087-80.583-1.9418",
    fill: "none",
    stroke: "#a4a4a4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 13.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m359.22 557.57 100.97 3.8835",
    fill: "none",
    stroke: "#a4a4a4",
    strokeLinecap: "round",
    strokeWidth: 13.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.bc96a7e35afefb1d418094822a9062dd.svg";
export { ForwardRef as ReactComponent };